import { inject, Injectable } from '@angular/core';
import { environment } from '../environments/environment';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Spinner } from './spinner';
import { catchError, map, Observable, throwError, EMPTY, finalize } from 'rxjs';
import { NgxUiLoaderService } from "ngx-ui-loader";
let baseURL = environment.api_url;

@Injectable({
  providedIn: 'root',
})
export class Api {
  loader: any;
  apiURL = environment.api_url;
  private readonly ngxLoader = inject(NgxUiLoaderService);

  constructor(
    private readonly http: HttpClient,
  ) {

  }
  getRequest(url: string, params?: any, loader: boolean = true): Observable<any> {
    params = params ?? {};
    if (loader) this.ngxLoader.start();
    if (params) {
      return this.http
        .get(baseURL + url, {
          params: params,

          withCredentials: true,
        })
        .pipe(
          map((response) => {
            if (loader) setTimeout(() => this.ngxLoader.stop(), 500);

            return response;
          })
        );
    } else {
      return this.http
        .get(baseURL + url, {
          withCredentials: true,

        })
        .pipe(
          map((response) => {
            if (loader) setTimeout(() => this.ngxLoader.stop(), 500);

            return response;
          })
        );
    }
  }

  postRequest1(
    url: string,
    data: any,
    showLoader: boolean = true,
    withCredentials: boolean = true
  ): Observable<any> {

    this.logCaller(url, 'POST').subscribe();

    if (showLoader) this.ngxLoader.start();

    return this.http
      .post(baseURL + url, data, {
        withCredentials: true,

      })
      .pipe(
        map((response) => {
          if (showLoader) {
            setTimeout(() => this.ngxLoader.stop(), 500);
          }
          return response;
        }),
        catchError((err) => {
          if (showLoader) {
            setTimeout(() => this.ngxLoader.stop(), 500);
          }
          if (url.includes('account')) {
            return throwError(() => err);
          }

          return throwError(() => err);
        })
      );
  }
  postRequest(
    url: string,
    data: any,
    loader: boolean = true,
    withCredentials: boolean = true
  ): Observable<any> {

    if (loader) {
      this.ngxLoader.start();
    }
    this.logCaller(url, 'POST').subscribe();


    return this.http.post(baseURL + url, data, {
      withCredentials
    }).pipe(
      finalize(() => {
        if (loader) {
          this.ngxLoader.stop();
        }
      })
    );
  }
  postRequestWithError(
    url: string,
    data: any,
    showLoader: boolean = true,
    withCredentials: boolean = true
  ): Observable<any> {
    // Check if entityId, and isPushedToEntity is passed
    this.logCaller(url, 'POST').subscribe();

    if (showLoader) this.ngxLoader.start();
    return this.http
      .post(baseURL + url, data, {
        withCredentials: true,

      })
      .pipe(
        map((response) => {
          if (showLoader) setTimeout(() => this.ngxLoader.stop(), 500);
          return response;
        }),
        catchError((err, caught) => {
          if (showLoader) setTimeout(() => this.ngxLoader.stop(), 500);
          throw err;
        })
      );
  }

  patchRequest(url: string, data: any): Observable<any> {
    this.ngxLoader.start();
    this.logCaller(url, 'PATCH').subscribe();
    return this.http
      .patch(baseURL + url, data, {
        withCredentials: true,

      })
      .pipe(
        map((response) => {
          setTimeout(() => this.ngxLoader.stop(), 500);
          return response;
        })
      );
  }

  updateRequest(url: string, data: any): Observable<any> {
    this.ngxLoader.start();
    this.logCaller(url, 'PUT').subscribe();
    return this.http
      .put(baseURL + url, data, {
        withCredentials: true,

      })
      .pipe(
        map((response) => {
          setTimeout(() => this.ngxLoader.stop(), 500);
          return response;
        })
      );
  }
  updateRequestData(
    url: string,
    data?: any,
    params?: HttpParams
  ): Observable<any> {
    this.ngxLoader.start();
    this.logCaller(url, 'PUT').subscribe();

    return this.http
      .put(baseURL + url, data, {
        withCredentials: true,

        params: params, // Pass query parameters here
      })
      .pipe(
        map((response) => {
          setTimeout(() => this.ngxLoader.stop(), 500);
          return response;
        })
      );
  }

  deleteRequest(
    url: string,
    options?: { data?: any; params?: any }
  ): Observable<any> {
    this.ngxLoader.start();
    this.logCaller(url, 'DELETE').subscribe();
    const httpParams = new HttpParams({
      fromObject: options?.params || {},
    });
    return this.http
      .delete(this.apiURL + url, {
        withCredentials: true,

        params: httpParams,
        body: options?.data,
      })
      .pipe(
        map((response) => {
          setTimeout(() => this.ngxLoader.stop(), 500);
          return response;
        })
      );
  }

  postRequestFile(api_url: any, data: any) {
    this.ngxLoader.start();
    this.logCaller(api_url, 'POST').subscribe();
    return new Promise((resolve, reject) => {
      this.http
        .post(baseURL + api_url, data, {
          responseType: 'arraybuffer',
          withCredentials: true,

        })
        .subscribe({
          next: (data): any => {
            this.ngxLoader.stop();
            resolve(data);
          },
          error: (err) => {
            this.ngxLoader.stop();
            // Reject with an Error object instead of a primitive value
            reject(new Error(err.error.error ?? 'An error occurred'));
          },
          complete: () => {
            this.ngxLoader.stop();
          },
        });
    });
  }

  getRequestFile(url: string, params?: any): Observable<any> {
    this.ngxLoader.start();
    return this.http
      .get(this.apiURL + url, {
        responseType: 'arraybuffer',
        params: params,
        withCredentials: true,

      })
      .pipe(
        map((response) => {
          // Hide the spinner after 500ms
          setTimeout(() => this.ngxLoader.stop(), 500);

          return response;
        })
      );
  }

  private logCaller(url: string, method: string) {
    return EMPTY
    const stack = new Error().stack;

    const message = `API Call - ${method} ${url} \n${stack}`;

    // Call api /api/common/log-activity
    return this.http
      .post(
        baseURL + "common/log-activity",
        {
          message: message,
        },
        {
          withCredentials: true,
        }
      )
      .pipe(
        map((response) => response),
        catchError((err) => {
          return EMPTY;
        })
      );
  }

}
